// The cases the signed-in person is a contact on, as `GET /me/cases` lists
// them. Only what the portal needs to decide how much of a case to show.

export interface MinimalCase {
  name: string;
  stage: string;
}

/** The person's access to `caseId` and, when it is minimal, the little they
 * may see. `unlisted` means the case is not among theirs (a care specialist
 * viewing as a customer, or a list that could not be read), which leaves the
 * case page to its own authorization. */
export type CaseAccess =
  | { kind: "full" }
  | { kind: "minimal"; case: MinimalCase }
  | { kind: "unlisted" };

export function caseAccessFor(raw: unknown, caseId: string): CaseAccess {
  const body =
    typeof raw === "object" && raw !== null
      ? (raw as Record<string, unknown>)
      : null;
  const rows: unknown[] = Array.isArray(body?.data) ? body.data : [];
  for (const row of rows) {
    if (typeof row !== "object" || row === null) continue;
    const item = row as Record<string, unknown>;
    if (item.record_id !== caseId) continue;
    if (item.access !== "minimal") return { kind: "full" };
    return {
      kind: "minimal",
      case: {
        name: typeof item.dcd_full_name === "string" ? item.dcd_full_name : "",
        stage: typeof item.stage === "string" ? item.stage : "",
      },
    };
  }
  return { kind: "unlisted" };
}
